import React, { useRef } from 'react';
import { useMouseHovered } from 'react-use';
import CTA from 'react-scale/components/elements/cta';

import styles from './hero.module.css';
import Grid from './Grid';

const HeroImage = () => {
  const containerRef = useRef(null);
  const { elX, elY } = useMouseHovered(containerRef, { bound: false, whenHovered: true });

  return (
    <section
      className={`${styles.mainWrapper} bg-black relative overflow-hidden md:pt-11 lg:py-0`}
      ref={containerRef}
    >
      <Grid elX={elX} elY={elY} />
      <div className="container relative z-10 flex h-full py-24 md:justify-center">
        <div>
          <header>
            <h1 className={`${styles.title} font-aeonik text-5xl md:text-6xl mt-2 capitalize`}>
              <span className={styles.titleI}>I</span>mage
            </h1>
            <div className="mt-8">
              <CTA
                cta={{
                  buttons: [
                    {
                      href: '/demo',
                      text: 'Book a Demo',
                      type: 'primary'
                    }
                  ],
                  hubspotForm: false,
                  hubspotModal: false
                }}
              />
            </div>
          </header>
        </div>
      </div>
    </section>
  );
};

export default HeroImage;
